import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=7ded24c8&"
import script from "./FileThumbnail.vue?vue&type=script&lang=js&"
export * from "./FileThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./FileThumbnail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports